<template>
  <v-wait for="loading subscription options">
    <spring-spinner
      :animation-duration="1500"
      :size="53"
      :color="'#b6bbff'"
      transition="fade"
      mode="out-in"
      :duration="1000"
      enter-active-class="enter-active"
      slot="waiting"
    />
    <div v-if="subscriptionOptions.length > 0">
      <!-- for normal account types -->
      <div v-if="!isEarlyBird && !isVip">
        <h2 class="text-size-default layout--margin-bottom-md">
          Available Credits
        </h2>
        <!-- remaining credits text -->
        <div class="layout--flex-space-between ">
          <span
            class="dashboard__credits"
            :class="{ 'dashboard__credits--negative': account.credits < 0 }"
            >{{ account.credits | numberWithCommas }}</span
          >
          <span>{{ creditsRemaining | numberToPercent }} remaining</span>
        </div>
        <!-- percentage bar -->
        <div class="dashboard__percentage-bar-wrap">
          <span class="dashboard__percentage-bar-background"></span>
          <span
            class="dashboard__percentage-bar"
            :style="{ width: barWidth }"
          ></span>
        </div>
        <!-- next cycle / monthly credits -->
        <div class="layout--flex-space-between layout--margin-bottom-md">
          <em
            >Next cycle begins
            {{ subscription.nextCreditResetDate | extraFancyDate }}</em
          >
          <span>{{ monthlyCredits | abbreviateNumber }}</span>
        </div>
      </div>
      <!-- end for normal account types -->

      <!-- for early bird / VIP accounts -->
      <div v-else>
        <h2 class="text-size-default layout--margin-bottom-md">
          Early Bird Credits
        </h2>
        <!-- remaining credits text -->
        <div class="layout--flex-space-between">
          <span
            class="dashboard__credits"
            :class="{ 'dashboard__credits--negative': account.credits < 0 }"
            >Unlimited</span
          >
          <span
            ><IconInfinity class="dashboard__icon dashboard__icon--large"
          /></span>
        </div>
        <!-- percentage bar -->
        <div class="dashboard__percentage-bar-wrap">
          <span class="dashboard__percentage-bar-background"></span>
          <span
            class="dashboard__percentage-bar"
            :style="{ width: '100%' }"
          ></span>
        </div>
      </div>
      <!-- end for early bird / VIP accounts -->
    </div>
  </v-wait>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { mapWaitingActions } from "vue-wait";

import IconExclamation from "../../../../assets/icons/iconAlertBar-Exclamation.svg";
import IconInfinity from "../../../../assets/icons/iconInfinity.svg";

export default {
  name: "available-credits",
  components: { IconExclamation, IconInfinity },
  mounted: function() {
    if (!this.subscriptionOptions.length > 0) {
      this.getSubscriptionOptions();
    }
  },
  methods: {
    ...mapWaitingActions("account", {
      getSubscriptionOptions: "loading subscription options",
    }),
  },
  computed: {
    ...mapGetters("account", [
      "subscription",
      "subscriptionOption",
      "subscriptionOptions",
      "account",
    ]),
    monthlyCredits: function() {
      const option = this.subscriptionOption(this.subscription.subscriptionType);
      if (option) {
        return option.monthlyCredits;
      }
    },
    costPerCredit: function() {
      return this.subscriptionOption(this.subscription.subscriptionType)
        .costPerCredit;
    },
    creditsRemaining: function() {
      return this.account.credits / this.monthlyCredits;
    },
    barWidth: function() {
      const percent = this.account.credits / this.monthlyCredits;
      if (percent > 1) {
        return "100%";
      }
      return percent * 100 + "%";
    },
    isEarlyBird() {
      return this.subscription.subscriptionType === 1;
    },
    isVip() {
      return this.subscription.subscriptionType === 2;
    },
  },
};
</script>

<style></style>
